import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useNetworkReport = () => useQuery({ queryKey: [`network-report`], queryFn: async () => {
    const callback = await API.get(`/network/report`)
    return callback?.data
}, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 60 * 24})

export default useNetworkReport